export default {
  Users: {
    TwoFactorAuthentication: {
      Button: 'ورود دومرحله‌ای',
      Modal: {
        Title: 'ورود دومرحله‌ای',
        Renew: {
          Button: 'دریافت احراز جدید',
          Message:
            'آیا برای دریافت احراز جدید مطمئن هستید؟<br/><b>پس از دریافت احراز جدید احراز قبلی کار نخواهد کرد.</b>',
        },
        Create: {
          Button: 'ایجاد',
        },
        Show: 'نمایش Qr کد',
        Code: {
          Message: 'کد تایید ارسال شده را وارد کنید',
          Label: 'کد پیامک شده را وارد کنید',
        },
      },
      Login: {
        Button: 'ورود دومرحله‌ای',
      },
    },
    AccessToken: {
      Title: 'لیست توکن‌ها',
      Os: 'سیستم عامل',
      Browser: 'مرورگر',
      Device: 'دستگاه',
      Ip: 'ای‌پی',
      Devices: {
        Desktop: 'کامپیوتر',
        Tablet: 'تبلت',
        Phone: 'تلفن همراه',
        Robot: 'ربات',
      },
    },
    ChangeRole: {
      Confirm: 'آیا از تغییر سطح این کاربر به _ROLE_ اطمینان دارید؟',
      Admin: 'مدیر',
      Support: 'پشتیبان',
    },
    UserInformation: {
      Button: 'گرفتن اطلاعات کاربر',
      Modal: {
        Title: 'گرفتن اطلاعات کاربر',
      },
      Tables: {
        UserInformation: {
          Name: 'نام',
          Email: 'ایمیل',
          Mobile: 'تلفن همراه',
          Status: 'وضعیت',
          Profile: 'پروفایل کاربر',
        },
      },
      Expansion: {
        Tickets: 'آخرین تیکت‌ها',
        Payments: 'آخرین پرداخت‌ها',
        Bills: 'آخرین فاکتور‌ها',
        Auth: 'آخرین احراز‌ها',
      },
    },
  },
}
